export const PRIORITY_RULES_VIOLATION_CODE = 'PriorityRulesViolation';
export const UNPROCESSED_ENTITY_CODE = 422;
export const CONFLICT_ERROR_RESPONSE_CODE = 409;
export const LEAVE_CONFIRM_MODAL_CONFIG = {
  title: 'Unsubmitted Designations',
  message:
    'You have designations that have not yet been submitted and will not be saved. Would you like to leave before submitting?',
  leaveBtnText: 'Leave',
  cancelBtnText: 'Continue Working',
} as const;